import { Vector2 } from 'three';
import { ref } from 'vue';

import { usePane } from '@resn/gozer-vue';

export const createPulseGradientRefs = (name = 'Pulse') => {
    const uPulseProgress = ref(0);
    const uPulseThickness = ref(0);
    const uPulseFalloff = ref(0.2);
    const uPulseMaxReach = ref(1.1);
    const uPulseCenter = ref(new Vector2(0.5, 0.5));
    const uPulseAspect = ref(1);

    const paneOptions = [
        { name: 'uPulseProgress', value: uPulseProgress, options: { min: 0, max: 1, step: 0.01 } },
        {
            name: 'uPulseThickness',
            value: uPulseThickness,
            options: { min: 0, max: 3, step: 0.01 },
        },
        { name: 'uPulseFalloff', value: uPulseFalloff, options: { min: 0, max: 1, step: 0.01 } },
        { name: 'uPulseMaxReach', value: uPulseMaxReach, options: { min: 0, max: 3, step: 0.01 } },
    ];

    // usePane(paneOptions, { title: name, expanded: false });

    return {
        uPulseProgress,
        uPulseThickness,
        uPulseFalloff,
        uPulseMaxReach,
        uPulseCenter,
        uPulseAspect,
    };
};

/**
 * Three.js uniforms object (`{ name: { value } }`) for radial pulse gradient.
 */
export const uniforms = () => {
    return {
        uPulseProgress: 0,
        uPulseThickness: 0,
        uPulseFalloff: 0.28,
        uPulseMaxReach: 1,
        uPulseCenter: new Vector2(0.5, 0.5),
        uPulseAspect: 1,
    };
};

/**
 * GLSL snippets: inject `uniforms` before your fragment `main`, `functions` / `funcs` with the library + include guard.
 */
export const shaderChunks = {
    uniforms: /* glsl */ `
        uniform float uPulseProgress;
        uniform float uPulseThickness;
        uniform float uPulseFalloff;
        uniform float uPulseMaxReach;
        uniform vec2 uPulseCenter;
        uniform float uPulseAspect;
    `,
    functions: /* glsl */ `
        #ifndef FNC_RADIAL_PULSE_GRADIENT
        #define FNC_RADIAL_PULSE_GRADIENT
        
        float radialPulseGradient(
            vec2 uv,
            float progress,
            float thickness,
            float falloff,
            float maxReach
        ) {
            vec2 center = vec2(0.5);
            float p = clamp(progress, 0.0, 1.0);
            float d = distance(uv, center);
            float wave = p * maxReach;
            float inner = max(wave - thickness, 0.0);
            float outer = wave;
            float f = max(falloff, 1e-5);
            float a = smoothstep(inner - f, inner, d);
            float b = 1.0 - smoothstep(outer, outer + f, d);
            // return 1.0;
            return clamp(a * b, 0.0, 1.0);
        }

        float radialPulseGradientAspect(
            vec2 uv,
            float aspect,
            float progress,
            float thickness,
            float falloff,
            float maxReach
        ) {
            vec2 center = vec2(0.5);
            vec2 q = uv - center;
            q.x *= aspect;
            float p = clamp(progress, 0.0, 1.0);
            float d = length(q);
            float wave = p * maxReach;
            float inner = max(wave - thickness, 0.0);
            float outer = wave;
            float f = max(falloff, 1e-5);
            float a = smoothstep(inner - f, inner, d);
            float b = 1.0 - smoothstep(outer, outer + f, d);
            return clamp(a * b, 0.0, 1.0);
        }

        #endif
    `,
};
